<script setup>

const googleRedirect = `${process.env.VUE_APP_API_URL}/website/auth/google/redirect`;
</script>
<template>
    <div class="vh-95 container mt-6 pt-3">
        <div class="row  d-flex justify-content-center align-items-center">
            <div class="col-md-6 d-flex justify-content-center align-items-center">
                <img
                  src="@/assets/img/illustrations/ingresar.png"
                  alt="Login Illustration"
                  style="width:100%; max-width:505px; height:auto;"
                />
            </div>
            <div class="col-md-6 d-flex justify-content-end">
                <div class="w-100 w-md-80">
                  <slot></slot>  
                    <div class="d-flex align-items-center gap-3 mt-5">
                        <span class="text-start">Ingresar con</span>
                        <div class="d-flex gap-2">
                            <a :href="googleRedirect"
                                class="btn d-flex align-items-center gap-2 shadow-none"
                                style="background-color: white; border: 1px solid #dadce0; color: #3c4043; font-weight: 500;">
                                <img src="@/assets/google.svg" class="text-secondary"
                                    alt="Google" width="20" height="20">
                                Google
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
/* Estilo para los iconos */
.social-icon {
    width: 18px;
    height: 18px;
}

/* Asegurar que los botones sean similares */
.btn {
    display: inline-flex;
    align-items: center;
    padding: 8px 16px;
    font-size: 14px;
    font-weight: 500;
}
</style>
